const orderType = {
    namespaced: true,
    state: () => ({
        selectedOrderType: 'dine_in'
    }),
    mutations: {
        SET_ORDER_TYPE(state, orderType) {
            state.selectedOrderType = orderType;
        }
    },
    actions: {
        setOrderType({ commit, dispatch }, orderType) {
            commit('SET_ORDER_TYPE', orderType);
            if (typeof localStorage !== 'undefined') {
                localStorage.setItem('orderType', orderType);
            }
            dispatch('cart/recalculateAllPrices', null, { root: true });
        },
        loadFromStorage({ commit }) {
            if (typeof localStorage !== 'undefined') {
                const savedOrderType = localStorage.getItem('orderType');
                if (savedOrderType && ['dine_in', 'click_collect', 'delivery'].includes(savedOrderType)) {
                    commit('SET_ORDER_TYPE', savedOrderType);
                }
            }
        }
    },
    getters: {
        selectedOrderType: (state) => state.selectedOrderType,
        isDelivery: (state) => state.selectedOrderType === 'delivery',
        isClickCollect: (state) => state.selectedOrderType === 'click_collect',
        isDineIn: (state) => state.selectedOrderType === 'dine_in'
    }
};
export default orderType;
